import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class LoteService extends BaseService {
  url = `${this.apiUrl}lote`;

  private listBehaviorSubject = new BehaviorSubject<any[]>([]);

  constructor(private http: HttpClient) {
    super();
  }

  getLote(loteId: number): Observable<any> {
    const lote = loteId.toString();
    return this.http.get<any>(`${this.url}/${lote}`);
  }

  getList(): Observable<any[]> {
    return this.http.get<any[]>(`${this.url}`);
  }

  getPaginate(skip: number = 0, limit: number = 0, sortBy: string, direction: string): Observable<any[]> {
    let toGet = `${this.url}/paginate/?skip=${skip}&limit=${limit}`;
    toGet = sortBy && direction ? toGet.concat(`&sort_by=${sortBy}&direction=${direction}`) : toGet;
    return this.http.get<any[]>(toGet);
  }

  saveLote(formData): Observable<any> {
    return this.http.post<any>(`${this.url}/`, formData);
  }

  updateLote(loteId: number, formData): Observable<any> {
    return this.http.put<any>(`${this.url}/${loteId}`, formData);
  }

  activeInactiveLote(loteId: number): Observable<any> {
    return this.http.patch<any>(`${this.url}/${loteId}`, {});
  }

  trasladoLote(lote1: string, lote2 : string): Observable<any> {
    return this.http.get<any>(`${this.url}/trasladolote?lote1=${lote1}&lote2=${lote2}`);
  }

}
